import { axiosInstance } from 'api/axios';
import { HiddenColumnsResponse } from './columnVisibility.types';

export const getHiddenColumns = async (): Promise<string[]> => {
  const response = await axiosInstance.get<HiddenColumnsResponse>(
    '/job/entry/container/hidden-columns',
  );

  if (response.data.status === 'OK' && response.data.result) {
    return response.data.result;
  }

  return [];
};

export const saveHiddenColumns = async (
  hiddenKeys: string[],
): Promise<void> => {
  await axiosInstance.post('/job/entry/container/hidden-columns', hiddenKeys);
};
